import { getLocalStorage } from 'shared/utils/localStorage';

function setSession(accessToken, expiresAt, refreshToken) {
  getLocalStorage().setItem('access_token', accessToken);
  getLocalStorage().setItem('expires_at', expiresAt);
  getLocalStorage().setItem('refresh_token', refreshToken);
}

function removeSession() {
  getLocalStorage().removeItem('access_token');
  getLocalStorage().removeItem('expires_at');
  getLocalStorage().removeItem('refresh_token');
  getLocalStorage().removeItem('impersonate');
}

const getAccessToken = () => {
  const accessToken = getLocalStorage().getItem('access_token');
  return accessToken;
};

const getRefreshToken = () => {
  const refreshToken = getLocalStorage().getItem('refresh_token');
  return refreshToken;
};

const isAuthenticated = () => {
  const expiresAt = JSON.parse(getLocalStorage().getItem('expires_at'));
  return getAccessToken() && Date.now() < expiresAt;
};

const getImpersonatedUser = () => {
  const userId = getLocalStorage().getItem('impersonate');
  return userId;
};

export {
  setSession,
  removeSession,
  isAuthenticated,
  getAccessToken,
  getRefreshToken,
  getImpersonatedUser,
};
